// extracted by mini-css-extract-plugin
var _1 = "IntegrationMentionError-module__animateUploadProgressBarWidth--BZr4_";
var _2 = "IntegrationMentionError-module__animatedBackground--ThrLu";
var _3 = "IntegrationMentionError-module__button--EXF83";
var _4 = "IntegrationMentionError-module__error--E1RBn";
var _5 = "IntegrationMentionError-module__icon--aVXCI";
var _6 = "IntegrationMentionError-module__title--u4yTs";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "button", _4 as "error", _5 as "icon", _6 as "title" }
